import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '../views/Home.vue';
import Covid19 from '../views/Covid19.vue';
import Team from '../views/Team.vue';
import Awards from '../views/Awards.vue';
import ShortlistingPanel from '../views/ShortlistingPanel.vue';
import Judges from '../views/Judges.vue';
import Sponsors from '../views/Sponsors.vue';
import PastProjects from '../views/PastProjects.vue';
import Submission from '../views/Submission.vue';
import Portfolio from '../views/Portfolio.vue';
import Contact from '../views/Contact.vue';
// Import new pages here
import PageNotFound from '../views/PageNotFound.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/covid-19',
        name: 'covid-19',
        component: Covid19,
    },
    {
        path: '/team',
        name: 'team',
        component: Team,
    },
    {
        path: '/awards',
        name: 'awards',
        component: Awards,
    },
    {
        path: '/shortlisting-panel',
        name: 'shortlisting-panel',
        component: ShortlistingPanel,
    },
    {
        path: '/judges',
        name: 'judges',
        component: Judges,
    },
    {
        path: '/sponsors',
        name: 'sponsors',
        component: Sponsors,
    },
    {
        path: '/past-projects',
        name: 'past-projects',
        component: PastProjects,
    },
    {
        path: '/submission',
        name: 'submission',
        component: Submission,
    },
    {
        path: '/portfolio',
        name: 'portfolio',
        component: Portfolio,
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
    },
    // Add new routes here
    {
        path: '/*',
        name: 'page-not-found',
        component: PageNotFound,
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
